import React from 'react';
import styles from './Tag.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {React.ReactNode} props.children
 * @param {string} props.fillColor
 * @param {number} props.height
 * @param {number} props.width
 * @param {string} props.title
 * @param {string=} props.points
 */
export default function Tag({
  className = '',
  children,
  fillColor,
  height,
  width,
  title,
  points = `0,0 ${width},5 ${width},${height - 3} 7,${height}`,
}) {
  return (
    <div
      className={`${styles.wrapper} ${className}`}
      aria-label={`${title} Tag`}
    >
      <svg className={styles.tagBg} fill={fillColor}>
        <polygon height={height} width={width} points={points} />
      </svg>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
